var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EmptyCategory",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1930",
    "data-name": "Ellipse 1930",
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#ededed"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10576",
    "data-name": "Group 10576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6049",
    "data-name": "Path 6049",
    d: "M72.88,26.87l-3.84,1-38.76,10-3.84,1a4.36,4.36,0,0,0-3.14,5.32L37.36,98.7a4.36,4.36,0,0,0,5.32,3.14h0l46.43-12h0a4.36,4.36,0,0,0,3.14-5.3v0L78.2,30a4.36,4.36,0,0,0-5.31-3.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6059",
    "data-name": "Path 6059",
    d: "M104.84,39h-48a6.15,6.15,0,0,0-6.13,6.13v56.32a6.16,6.16,0,0,0,6.13,6.14h48a6.16,6.16,0,0,0,6.13-6.14V45.11A6.14,6.14,0,0,0,104.84,39Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10589",
    "data-name": "Group 10589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6073",
    "data-name": "Path 6073",
    d: "M46.5,50.59,70,44.53a1,1,0,1,0-.51-2h0L46,48.61a1,1,0,1,0,.5,2Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6074",
    "data-name": "Path 6074",
    d: "M75.66,45.56a1,1,0,0,0-1.2-.75h0L46.76,52a1,1,0,1,0,.51,2l27.65-7.2a1,1,0,0,0,.75-1.2Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6075",
    "data-name": "Path 6075",
    d: "M42.49,56.79a.49.49,0,0,0,.35-.6h0l-1.91-7.4h0a.49.49,0,0,0-.6-.35h0L32,50.58h0a.49.49,0,0,0-.35.6h0l1.91,7.4h0a.47.47,0,0,0,.58.35h0l8.32-2.15Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6076",
    "data-name": "Path 6076",
    d: "M46.35,71.75a.49.49,0,0,0,.35-.6h0l-1.91-7.4h0a.49.49,0,0,0-.6-.35h0l-8.31,2.14h0a.49.49,0,0,0-.35.6h0l1.91,7.4h0a.49.49,0,0,0,.6.35h0l8.31-2.15Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6077",
    "data-name": "Path 6077",
    d: "M48.65,78.71h0a.49.49,0,0,0-.6-.35h0L39.73,80.5h0a.49.49,0,0,0-.35.6h0l1.91,7.4h0a.49.49,0,0,0,.6.35h0L50.2,86.7h0a.49.49,0,0,0,.34-.6Z",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M104.83,40.75h-48a4.37,4.37,0,0,0-4.37,4.36v56.32a4.37,4.37,0,0,0,4.37,4.37h48a4.36,4.36,0,0,0,4.37-4.35V45.11a4.36,4.36,0,0,0-4.36-4.36Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6068",
    "data-name": "Path 6068",
    d: "M84.71,50.27H66.83a1,1,0,0,1,0-2H84.71a1,1,0,0,1,0,2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6069",
    "data-name": "Path 6069",
    d: "M88.93,53.71H66.83a1,1,0,0,1,0-2h22.1a1,1,0,0,1,0,2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6070",
    "data-name": "Path 6070",
    d: "M101.6,98.84H60.06a1.15,1.15,0,0,1-1.23-1V70.32a1.15,1.15,0,0,1,1.23-1H101.6a1.14,1.14,0,0,1,1.23,1V97.79A1.14,1.14,0,0,1,101.6,98.84Z",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1935",
    "data-name": "Ellipse 1935",
    cx: 61.5,
    cy: 50.9,
    r: 2.5,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M97.12,59.82H60.86c-.83,0-1.5-.45-1.5-1s.66-1,1.5-1H97.12c.83,0,1.5.45,1.5,1S98,59.82,97.12,59.82Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M101.4,63.27H60.79c-.79,0-1.43-.45-1.43-1s.64-1,1.43-1H101.4c.79,0,1.43.45,1.43,1S102.19,63.27,101.4,63.27Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063-2",
    "data-name": "Path 6063-2",
    d: "M101.4,66.72H60.79c-.79,0-1.43-.45-1.43-1s.64-1,1.43-1H101.4c.79,0,1.43.44,1.43,1S102.19,66.72,101.4,66.72Z",
    fill: "#e6e6e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.89567e19c5b924c4a2bb9a0c1feab00a.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;